import Rows from "../jslibs/Rows";
import { TUnit } from "./Recipes";

export type TFoodEntry = {
    id:number|string
    amount:number
    unit?:TUnit
}
export interface IMeal {
    _id:string
    name:string
    user:string
    created:number
    updated:number
    foods:TFoodEntry[]
}

export default class Meals extends Rows<string, IMeal>{
    private _userId:string
    constructor(userId:string, meals:IMeal[]) {
        super(meals)
        this._userId = userId
    }
    get userId(){return this._userId}
    rowKey(row: IMeal): string { return row._id }
}